<template>
  <div id="app">
    <Nav></Nav>
    <div class="toptit"></div>
    <div class="block">
      <!-- <img src="../assets/aboutUs.png"
      alt="">-->
      <h1><span>卡恩</span>欢迎您的加入</h1>
    </div>
    <div class="tabUs">
      <!-- <span class="tabLabelLx"
            id="tabLabelLx"
            :style="tabLabelLx"
            @click="tabLabelLxClick()">联系我们</span>
      <span class="tabLabelJr"
            id="tabLabelJr"
            :style="tabLabelJr"
      @click="tabLabelJrClick()">加入管理</span>-->
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="联系我们" name="first">
          <div class="contactUS">
            <div class="contactLeft">
              <div>
                <p class="contactLeftBlod">上海卡恩文化传播股份有限公司</p>
                <p class="contactNum">SHANGHAI COUNTON CO.,LTD.</p>
              </div>
              <div>
                <p class="contactLeftBlod">
                  上海市长宁区安化路492号长宁德必易园A座4楼
                </p>
                <p class="contactNum">
                  4F, Building A，No. 492 Anhua Rd., Changning District,
                  Shanghai
                </p>
              </div>
              <div class="phoneNum">
                <p class="contactLeftBlod">电话：021-5239 8600</p>
                <p class="contactLeftBlod">传真：021-5239 8682</p>
                <p class="contactLeftBlod">400热线：400 820 3371</p>
              </div>
            </div>
            <div class="contactRight">
              <img src="../assets/rongyu/lianxi.jpg" alt />
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="加入我们" name="second">
          <div class="joinUs">
            <h2>简历投递地址: recruit@counton.com.cn</h2>
            <div class="firstPart">
              <h3>视觉总监/资深经理</h3>
              <h4>工作地点：上海</h4>
              <div class="contentDetail">
                <div class="firstLeft">
                  <p style="width: 100%">你需要:</p>
                  <h5>1. 视觉效果指导和监督</h5>
                  <div>
                    <span class="titNum">-</span>
                    <span
                      >从主流市场和客户审美角度出发,定性定调公司对内(也包括对内)创意类、宣传类等物料和作品的视觉呈现效果;</span
                    >
                  </div>
                  <div>
                    <span class="titNum">-</span>
                    <span
                      >在视觉和审美端,目标在客户方打造出属于卡恩独有的专业、创意、有质地的企业形象.</span
                    >
                  </div>
                  <h5>2. 创意项目（完稿作品）指导和监督</h5>
                  <div>
                    <span class="titNum">-</span>
                    <span
                      >协助创意总监和设计师团队,更好理解、分析客户在创意构想方面的需求,把控设计风格大方向;</span
                    >
                  </div>
                  <div>
                    <span class="titNum">-</span>
                    <span
                      >运用独特视觉修养和艺术判断力,对创意部作品进行美术指导,监督并保证提高产品(或作品)质量.</span
                    >
                  </div>
                  <h5>3. 其他上级领导交付的相关工作内容</h5>
                </div>
                <div class="firstRight">
                  <p style="width: 100%">期望你:</p>
                  <div>
                    <span class="titNum">1.</span>
                    <p>
                      广告学、美术设计或相关专业毕业,全日制专科及以上学历.8年及以上广告或相关行业美术指导经验,具备优秀平面设计能力者更佳;
                    </p>
                  </div>
                  <div>
                    <span class="titNum">2.</span>
                    <p>
                      具备扎实的美术美学审美基础,出色的平面创作能力和指导能力;
                    </p>
                  </div>
                  <div>
                    <span class="titNum">3.</span>
                    <p>
                      善于捕捉主流市场审美品位,抱有精益求精、不断创新的设计创意热情,对于艺术品鉴和时尚潮流有自己的判断力.同时具备不可或缺的执行力;
                    </p>
                  </div>
                  <div>
                    <span class="titNum">4.</span>
                    <p>能够胜任高强度、高要求、高效率的工作节奏;</p>
                  </div>
                  <div>
                    <span class="titNum">5.</span>
                    <p>善于沟通和学习,思路清晰,反应敏捷;</p>
                  </div>
                  <div>
                    <span class="titNum">6.</span>
                    <p>具备团队合作意识和共荣格局,良好的跨部门协调能力.</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="secondPart">
              <h3>招聘资深主管</h3>
              <h4>工作地点：上海</h4>
              <div class="contentDetail">
                <div class="secondLeft">
                  <p style="width: 100%">你需要:</p>
                  <div>
                    <span class="titNum">1.</span>
                    <p>
                      根据公司战略发展需要,参与制定招聘计划,拟定招聘体系和方案;
                    </p>
                  </div>
                  <div>
                    <span class="titNum">2.</span>
                    <p>
                      分析用人部门的招聘岗位,梳理职位JD,与用人部门紧密沟通共同完成招聘计划;
                    </p>
                  </div>
                  <div>
                    <span class="titNum">3.</span>
                    <p>
                      组织实施完成招聘工作:发布招聘广告、简历筛选、搜索、评估候选人、面试安排等;
                    </p>
                  </div>
                  <div>
                    <span class="titNum">4.</span>
                    <p>
                      把控招聘各项流程的规范管理,组织和参与面试,评估判断候选人匹配度,跟踪面试结果;
                    </p>
                  </div>
                  <div>
                    <span class="titNum">5.</span>
                    <p>
                      甄别、选择、建立和维护合适的招聘渠道,充分利用各招聘渠道满足公司的人才需求;
                    </p>
                  </div>
                  <div>
                    <span class="titNum">6.</span>
                    <p>
                      提供招聘数据和招聘效果进行统计与分析报告,完善公司人才招聘制度,优化招聘流程;
                    </p>
                  </div>
                  <div>
                    <span class="titNum">7.</span>
                    <p>建立公司储备人才库,做好人才储备;</p>
                  </div>
                  <div>
                    <span class="titNum">8.</span>
                    <p>
                      跟踪、督促、协助用人部门开展入职新员工试用期阶段性考核评估;
                    </p>
                  </div>
                  <div>
                    <span class="titNum">9.</span>
                    <p>协助完成其他相关人力资源工作.</p>
                  </div>
                </div>
                <div class="secondRight">
                  <p style="width: 100%">期望你:</p>
                  <div>
                    <span class="titNum">1.</span>
                    <p>大专及以上学历,5年以上招聘管理经验;</p>
                  </div>
                  <div>
                    <span class="titNum">2.</span>
                    <p>熟悉招聘流程,招聘经验丰富,具备良好的人才甄别技能;</p>
                  </div>
                  <div>
                    <span class="titNum">3.</span>
                    <p>
                      有良好的职业操守,责任心、原则性强,工作细致有条理,有良好的团队合作精神;
                    </p>
                  </div>
                  <div>
                    <span class="titNum">4.</span>
                    <p>具有优秀的书面、口头表达能力,擅于沟通与协调;</p>
                  </div>
                  <div>
                    <span class="titNum">5.</span>
                    <p>熟悉国家劳动人事政策、法规;</p>
                  </div>
                  <div>
                    <span class="titNum">6.</span>
                    <p>熟悉人力资源其他各项事务性实战工作优先;</p>
                  </div>
                  <div>
                    <span class="titNum">7.</span>
                    <p>大学英语四级及以上优先.</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="firstPart">
              <h3>资深视觉设计师</h3>
              <h4>工作地点：上海</h4>
              <div class="contentDetail">
                <div class="firstLeft">
                  <h5>一、视觉效果指导和监督</h5>
                  <div>
                    <span class="titNum">1.</span>
                    <span
                      >作为主视觉,负责业务部门项目相关的创意发想,视觉及其延展设计;</span
                    >
                  </div>
                  <div>
                    <span class="titNum">2.</span>
                    <span
                      >从主流市场和客户审美角度出发,定性定调公司内外部,创意类、宣传类等物料和作品的视觉呈现效果;</span
                    >
                  </div>
                  <div>
                    <span class="titNum">3.</span>
                    <span
                      >在视觉和审美端,目标在客户方打造出属于卡恩独有的创意、专业、有质地的企业形象.</span
                    >
                  </div>
                </div>
                <div class="firstRight">
                  <h5> 二、创意项目（完稿作品）指导和监督</h5>
                  <div>
                    <span class="titNum">1.</span>
                    <p>
                      协助创意总监和设计师团队,更好理解、分析客户在创意,视觉方面的需求,把控设计风格大方向;
                    </p>
                  </div>
                  <div>
                    <span class="titNum">2.</span>
                    <p>
                      运用独特视觉修养和艺术判断力,对创意部作品进行美术指导,监督并保证提高产品(或作品)质量.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="secondPart">
              <h3>物流专员</h3>
              <h4>工作地点：上海</h4>
              <div class="contentDetail">
                <div class="secondLeft">
                  <p style="width: 100%">你需要:</p>
                  <div>
                    <span class="titNum">1.</span>
                    <p>
                      全面监督和执行物流配送工作,物流在途信息跟踪整理与反馈;
                    </p>
                  </div>
                  <div>
                    <span class="titNum">2.</span>
                    <p>物流信息的系统录入以及部门资料的整理、汇总与归档工作;</p>
                  </div>
                  <div>
                    <span class="titNum">3.</span>
                    <p>部门与其他部门的联系与协调,保证信息管道的畅通;</p>
                  </div>
                  <div>
                    <span class="titNum">4.</span>
                    <p>公司RDC仓库存管理以及每月与物流商的账务核对和结算.</p>
                  </div>
                </div>
                <div class="secondRight">
                  <p style="width: 100%">期望你:</p>
                  <div>
                    <span class="titNum">1.</span>
                    <p>3年以上物流专员或者助理工作经验,有国际物流经验优先;</p>
                  </div>
                  <div>
                    <span class="titNum">2.</span>
                    <p>熟悉物流体系和制造流程;</p>
                  </div>
                  <div>
                    <span class="titNum">3.</span>
                    <p>
                      工作积极,具备较强的服务意识,主动配合主管工作安排并能够给予及时的建议;
                    </p>
                  </div>
                  <div>
                    <span class="titNum">4.</span>
                    <p>
                      较强的语言表达和沟通协调能力,熟练运用/操作Office办公软件.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <BottomNav></BottomNav>
  </div>
</template>

<script>
import Nav from "../components/Nav";
import BottomNav from "../components/BottomNav";
import Vue from "vue";
import $ from "jquery";
export default {
  name: "AboutUs",
  data() {
    return {
      activeName: "first",
      tabLabelJr: [{ color: "#FFFFFF" }],
      tabLabelLx: [{ color: "#1E1E1E" }],
      imagesBox: [
        {
          id: 0,
          idView: require("../assets/bg-top.png"),
        },
        {
          id: 1,
          idView: require("../assets/bg-top.png"),
        },
        {
          id: 2,
          idView: require("../assets/bg-top.png"),
        },
      ],
      // isFirst: true,
      // isSecond:false
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
      console.log($(".joinus"));
      if (tab.name === "first") {
        this.isFirst = true;
        this.isSecond = false;
      }
      if (tab.name === "second") {
        this.isFirst = false;
        this.isSecond = true;
      }
    },
    // handleClick(tab, event) {
    // if (tab.index == 0) {
    //   this.tabLabelJr = { color: "#FFFFFF" };
    //   this.tabLabelLx = { color: "#1E1E1E" };
    // }
    // if (tab.index == 1) {
    //   this.tabLabelJr = { color: "#1E1E1E" };
    //   this.tabLabelLx = { color: "#FFFFFF" };
    // }
    // },
    tabLabelLxClick(event) {
      this.activeName = "first";
      this.tabLabelJr = { color: "#FFFFFF" };
      this.tabLabelLx = { color: "#1E1E1E" };
    },
    tabLabelJrClick(event) {
      this.activeName = "second";
      this.tabLabelJr = { color: "#1E1E1E" };
      this.tabLabelLx = { color: "#FFFFFF" };
    },
  },
  mounted() {
    $("body").scrollTop(0);

    document.querySelector("body").scrollTo(0, 0);
    if (this.$route.params.c === undefined) {
      this.activeName = "first";
    } else {
      this.activeName = this.$route.params.c;
    }
    window.onscroll = function () {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      var topNav = document.getElementById("topNav");
      if (scrollTop > 0) {
        topNav.style.width = "100%";
        topNav.style.position = "fixed";
        topNav.style.top = "0";
        topNav.style.left = "0";
        topNav.style.paddingLeft = "33.5%";
        // topNav.style.zIndex = 11;
      } else {
        // topNav.style.paddingLeft = "0%";
        // topNav.style.width = "32.42%";
        // topNav.style.left = "33.5%";
        // topNav.style.zIndex = 9;
      }
      // if (scrollTop = 0) {
      //   topNav.style.width = "29.42%";
      // }
    };
    var lianxiwomen = document.getElementById("lianxiwomen");
    var jiaruwomen = document.getElementById("jiaruwomen");
    var paneSecond = document.getElementById("pane-second");
    var paneFirst = document.getElementById("pane-first");
    var tabFirst = document.getElementById("tab-first");
    var tabSecond = document.getElementById("tab-second");
    var lianxiwomen1 = document.getElementById("lianxiwomen1");
    var jiaruwomen1 = document.getElementById("jiaruwomen1");
    lianxiwomen.onclick = function () {
      paneFirst.style.display = "block";
      paneSecond.style.display = "none";
      $("#tab-first").addClass("is-active");
      $("#tab-second").removeClass("is-active");
      document.documentElement.scrollTop = 0;
    };
    jiaruwomen.onclick = function () {
      paneFirst.style.display = "none";
      paneSecond.style.display = "block";
      $("#tab-first").removeClass("is-active");
      $("#tab-second").addClass("is-active");
      document.documentElement.scrollTop = 0;
    };
    lianxiwomen1.onclick = function () {
      paneFirst.style.display = "block";
      paneSecond.style.display = "none";
      $("#tab-first").addClass("is-active");
      $("#tab-second").removeClass("is-active");
      document.documentElement.scrollTop = 0;
    };
    jiaruwomen1.onclick = function () {
      paneFirst.style.display = "none";
      paneSecond.style.display = "block";
      $("#tab-first").removeClass("is-active");
      $("#tab-second").addClass("is-active");
      document.documentElement.scrollTop = 0;
    };
    var contactUs = document.getElementById("#contactUs");
    contactUs.onclick = function () {
      document.documentElement.scrollTop = 0;
    };
  },
  components: { Nav, BottomNav },
};
</script>

<style lang="less" scoped>
#app {
  font-family: "微软雅黑";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position: relative;
  @media screen and (min-width: 140px) {
    min-width: 1050px;
    margin: 0 auto;
  }
  @media screen and (min-width: 1920px) {
    min-width: 1240px;
    margin: 0 auto;
  }
}
.image {
  width: 100%;
}
.logoImg {
  width: 141px;
  height: 86px;
}
.tit {
  text-align: left;
  h1 {
    color: #fce04f;
    font-size: 61px;
    font-family: Impact;
    font-weight: 400;
    border-bottom: 2px solid #fce04f;
    width: 67px;
  }
  p {
    font-size: 20px;
  }
}
.block {
  background-color: #333333;
  height: 100px;
  display: flex;
  align-items: center;
  h1 {
    color: #ffffff;
    line-height: 100px;
    width: fit-content;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    margin: 0 0 0 35%;
    @media screen and (min-width: 140px) {
      font-size: 24px;
    }
    @media screen and (min-width: 1920px) {
      font-size: 26px;
    }
    span {
      border-bottom: 4px solid #fce04f;
      padding-bottom: 5px;
    }
  }
}
.toptit {
  width: 100%;
  height: 56px;
}
.el-menu--horizontal > .el-menu-item {
  color: #666666 !important;
}

.tabUs {
  position: relative;
  margin: 100px auto 0;
  @media screen and (min-width: 140px) {
    width: 90%;
  }
  @media screen and (min-width: 1240px) {
    width: 75%;
  }
  @media screen and (min-width: 1510px) {
    width: 65%;
  }
}

.tabLabelLx {
  position: absolute;
  left: 300px;
  top: 7px;
  z-index: 1000;
  font-size: 20px;
}
.tabLabelLx:hover {
  cursor: pointer;
}
.tabLabelJr {
  position: absolute;
  left: 900px;
  top: 7px;
  z-index: 1000;
  font-size: 20px;
}
.tabLabelJr:hover {
  cursor: pointer;
}

.contactUS {
  width: 100%;
  margin: 50px auto 0;
  display: flex;
  justify-content: space-between;
  .contactLeft {
    width: 50%;
    padding-left: 25px;
    font-size: 20px;
    // float: left;
    div {
      margin-top: 17px;
      p {
        margin: 0;
        text-align: left;
      }
    }
    .phoneNum {
      p {
        line-height: 40px;
        @media screen and (min-width: 140px) {
          line-height: 30px;
        }
        @media screen and (min-width: 1510px) {
          line-height: 40px;
        }
      }
    }
    .contactLeftBlod {
      font-weight: bold;
      color: rgba(69, 69, 69, 1);
      line-height: 30px;
      @media screen and (min-width: 140px) {
        font-size: 18px;
      }
      @media screen and (min-width: 1920px) {
        font-size: 24px;
      }
    }
    .contactNum {
      font-size: 16px;
      font-family: ArialMT;
      font-weight: 400;
      color: rgba(69, 69, 69, 1);
      line-height: 25px;
    }
  }
  .contactRight {
    // float: right;
    width: 50%;
    margin-bottom: 110px;
    margin-right: 18px;
    img {
      width: 100%;
    }
  }
}
.joinUs {
  width: 100%;
  margin: 50px auto;
  h2 {
    font-size: 28px;
    // margin-bottom: 49px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    line-height: 40px;
  }
  h3 {
    text-align: left;
    padding-bottom: 5px;
    width: fit-content;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    border-bottom: 4px solid #fce04f;
    color: #666;
    @media screen and (min-width: 140px) {
      font-size: 18px;
    }
    @media screen and (min-width: 1920px) {
      font-size: 24px;
    }
  }
  h4 {
    font-weight: bold;
    text-align: left;
    color: #666;
    margin-top: 0;
    font-size: 16px;
  }
  h5 {
    text-align: left;
    font-size: 16px;
    margin: 0;
    line-height: 50px;
    font-weight: bold;
    color: rgba(102, 102, 102, 1);
  }
  span {
    text-align: left;
    display: block;
    font-size: 16px;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
  }
  p {
    text-align: left;
    margin: 0;
    font-size: 16px;
    color: #666;
    display: inline-block;
  }
  .firstPart {
    display: flex;
    flex-flow: column;
    margin-top: 50px;
    .contentDetail {
      display: flex;
      justify-content: space-between;
    }

    .firstLeft {
      // float: left;
      width: 540px;
      padding-right: 20px;
      div {
        display: flex;
        margin-top: 10px;
      }
    }
    .firstRight {
      // float: right;
      width: 540px;
      padding-left: 20px;
      div {
        display: flex;
        margin-top: 10px;
      }
      p {
        text-align: left;
      }
    }
  }
  .secondPart {
    display: flex;
    flex-flow: column;
    margin-top: 60px;
    .contentDetail {
      display: flex;
      justify-content: space-between;
    }
    .secondLeft {
      width: 540px;
      padding-right: 20px;
      div {
        display: flex;
        margin-top: 10px;
      }
    }
    .secondRight {
      width: 540px;
      padding-left: 20px;
      div {
        display: flex;
        margin-top: 10px;
      }
      p {
        text-align: left;
      }
    }
  }
  .titNum {
    display: inline-block;
    padding-left: 0;
    padding-right: 5px;
  }
}
</style>
<style lang="less">
.el-tabs__nav-wrap::after {
  width: 0 !important;
}
.el-tabs__nav {
  width: 100% !important;
}
#tab-first {
  height: 65px;
  line-height: 65px;
  font-size: 24px;
  width: 50%;
  font-weight: 400;
  margin-left: 7px;
}
#tab-second {
  height: 65px;
  width: 50%;
  line-height: 65px;
  font-size: 24px;
  font-weight: 400;
}

.el-carousel__button {
  width: 11px;
  height: 11px;
  border-radius: 50%;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.el-tabs__item {
  width: 610px;
  font-size: 20px;
  // transform: skew(-30deg); /*设置倾斜度为-30*/
  // -webkit-transform: skew(-30deg);
  // -moz-transform: skew(-30deg);
  // -o-transform: skew(-30deg);
  // -ms-transform: skew(-30deg);
  background-color: rgb(53, 50, 53);
  color: #ffffff;
}
.el-tabs__item.is-active {
  background-color: #fce04f;
  color: #1e1e1e;
}
.el-tabs__active-bar {
  display: none;
}
// .el-submenu__title:hover {
//   background-color: #fff !important;
// }
.el-submenu__title {
  color: #333 !important;
}
.el-submenu__title a {
  color: #333 !important;
}

// .el-carousel__container {
//   height: 500px;
// }
</style>